import "core-js/stable";
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "./assets/css/global.css"
// import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
// Vue.use(ElementUI);
import { Button, Pagination,Select,Form, FormItem,Option, Input, Message ,Loading,Checkbox,CheckboxGroup,CheckboxButton} from 'element-ui';
Vue.use(Button).use(Form).use(FormItem).use(Input).use(Checkbox).use(CheckboxGroup).use(CheckboxButton).use(Pagination).use(Select).use(Option);
Vue.prototype.$message = Message
Vue.prototype.$loading = Loading.service;
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
